module.exports = __webpack_public_path__ + "static/media/main idea.fddec37d.mp3";